import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { observable, Observable } from "rxjs";
import { brands } from "./api-interfaces/brands.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIBrandsService {

    ApiURL: string = "";
    constructor(private http: HttpClient, private helperService: HelperService) {
        this.ApiURL = environment.brandsUrl + 'brands/';
    }

    public get(id: string): Observable<brands[]>{
      const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
      const requestOptions = {
        headers: headers,
      };

      return this.http.get<brands[]>(this.ApiURL +  encodeURIComponent(id), requestOptions);

    }

    public getBrandAdvisor(id: number): Observable<any>{
    {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.get(this.ApiURL + "GetBrandsByAdvisorID/"+ encodeURIComponent(id), requestOptions);
      }
    }

    public getBrandWorkshop(id: number): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.get<any>(this.ApiURL + "GetBrandsByWorkshopID/"+ encodeURIComponent(id), requestOptions);
    }

    public getBrandsRetail(id?: number): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        if (id) {
            return this.http.get(this.ApiURL + "GetBrandsByretailId/"+ encodeURIComponent(id), requestOptions);
        }
        else return this.http.get(this.ApiURL + "GetBrandsByretailId/", requestOptions);
    }
    public getBrandsRetailDerco(countryId?: number): Observable<any> {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.helperService.TokenBooking}`,
      });
      const options = { headers };
      return this.http.post<any>(`${this.ApiURL}GetBrandsRetailByCountryId/`, { countryId }, options)
    }

    public getBrandsByCountryId(countryId: number):Observable<brands[]> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return  this.http.get<brands[]>(this.ApiURL+ 'GetBrandsByCountry/'+ countryId, requestOptions);
    }

}


